import React from 'react';
import Navbar from '../../components/Navbar';
import Footer from '../../components/Footer';
import QuoteForm from './QuoteForm';

const QuotationPage: React.FC = () => {
  return (
    <>
      <Navbar />
      <main className="min-h-screen bg-gray-50 py-10">
        <div className="max-w-5xl mx-auto px-4">
          <h1 className="text-2xl font-bold text-gray-900 mb-6">Generador de Cotizaciones</h1>
          <p className="text-sm text-gray-600 mb-6">
            Completa los datos y genera un PDF con el estilo personalizado de Royal Trucking listo para enviar al cliente.
          </p>
          <QuoteForm />
        </div>
      </main>
      <Footer />
    </>
  );
};

export default QuotationPage;
